/* eslint-disable @reatom/unit-naming-rule */

import { atom } from '@reatom/framework'

import { AsyncStateN, pipe } from '@blade/std-lib'
import { CurrencyRef } from '@root/entities/currency/model'
import { reatomDataTable } from '@root/shared/ui-kit'

import { blacklistCurrenciesTableColumns } from '../ui/blacklist-currencies-columns'

import { blacklistCurrenciesModel } from './reatom-blacklist-currencies'

export const reatomBlacklistCurrenciesTable = () => {
  const stateAtom = atom((ctx) => {
    const state = ctx.spy(blacklistCurrenciesModel)
    return pipe(
      state,
      AsyncStateN.map((it) => ({ data: it })),
    )
  })
  return reatomDataTable({
    columns: blacklistCurrenciesTableColumns,
    name: 'blacklistCurrenciesTable',
    stateAtom: stateAtom,
    getId: (currency) => CurrencyRef.toString(currency),
  })
}

export type BlacklistCurrenciesTableModel = ReturnType<
  typeof reatomBlacklistCurrenciesTable
>
